import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Home, ChevronDown } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLegalDropdownOpen, setIsLegalDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // If already on home page, just scroll
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const goToHome = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const navigateToLegalPage = (path) => {
    navigate(path);
    setIsLegalDropdownOpen(false);
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo" onClick={goToHome} style={{ cursor: 'pointer' }}>
          <span className="logo-text">White Label Devs</span>
        </div>
        
        <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
          <button className="nav-link" onClick={goToHome}>
            <Home size={18} />
            Home
          </button>
          <button className="nav-link" onClick={() => scrollToSection('services')}>Services</button>
          <button className="nav-link" onClick={() => scrollToSection('pricing')}>Pricing</button>
          <button className="nav-link" onClick={() => scrollToSection('process')}>Process</button>
          <button className="nav-link" onClick={() => scrollToSection('contact')}>Contact</button>
          
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setIsLegalDropdownOpen(true)}
            onMouseLeave={() => setIsLegalDropdownOpen(false)}
          >
            <button 
              className="nav-link nav-link-dropdown"
              onClick={() => setIsLegalDropdownOpen(!isLegalDropdownOpen)}
            >
              Legal
              <ChevronDown size={16} />
            </button>
            <div className={`dropdown-menu ${isLegalDropdownOpen ? 'show' : ''}`}>
              <button className="dropdown-item" onClick={() => navigateToLegalPage('/privacy-policy')}>
                Privacy Policy
              </button>
              <button className="dropdown-item" onClick={() => navigateToLegalPage('/terms-of-service')}>
                Terms of Service
              </button>
              <button className="dropdown-item" onClick={() => navigateToLegalPage('/nda-template')}>
                NDA Template
              </button>
              <button className="dropdown-item" onClick={() => navigateToLegalPage('/refund-policy')}>
                Refund Policy
              </button>
              <button className="dropdown-item" onClick={() => navigateToLegalPage('/disclaimer')}>
                Disclaimer
              </button>
            </div>
          </div>
        </nav>

        <button className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;